import { SearchIcon } from '@svgs'
import clsx from 'clsx'
import React, { FC, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { InputField } from 'src/components/ui'
import SortSelect from 'src/components/elements/sort-select/SortSelect'
import { setValue } from 'src/redux/slices/propertySearchSlice'
import { RootState } from 'src/redux/store'

interface IHeadSection {
  className?: string
  title?: string
  isSearch?: boolean
  isSorting?: boolean
}

const HeadSection: FC<PropsWithChildren<IHeadSection>> = ({
  className,
  title,
  isSearch,
  isSorting,
  children,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { search } = useSelector((state: RootState) => state.propertySearch)

  return (
    <div
      className={clsx(
        'flex flex-row gap-5 justify-between text-ink min-h-10 items-center',
        className,
      )}
    >
      {title && (
        <h2 className="py-2 text-xl md:text-[1.375rem] font-extrabold leading-tight text-ink">
          {title}
        </h2>
      )}
      {children}
      {/* Removed fixed filter button - now handled per page */}
      <div className="hidden md:flex items-center gap-4 md:flex-shrink-0">
        {isSearch && (
          <InputField
            value={search}
            onChange={(e) => dispatch(setValue(e.currentTarget.value))}
            className="max-w-[10.625rem] w-full"
            placeholder={t('search')}
            iconAfter={<SearchIcon />}
          />
        )}
        {isSorting && <SortSelect />}
      </div>
    </div>
  )
}

export default HeadSection
